import(/* webpackMode: "eager", webpackExports: ["ChangelogPageContent"] */ "/app/components/frontend/changelog/changelog-page-content.tsx");
